<template>
  <v-container>
    <v-alert v-if="errorMsg" type="error" dense outlined>
      {{ errorMsg }}
    </v-alert>
    <div
      style="height: 80vh"
      class="d-flex align-stretch"
      v-if="!errorMsg && resumeUrl"
    >
      <embed :src="resumeUrl" width="100%" height="100%" />
    </div>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      resumeUrl: "",
      errorMsg: "",
    };
  },
  mounted() {
    this.$utils.visit(this);
    this.reviewId = this.$route.query.reviewId;
    if (!this.reviewId) {
      this.errorMsg = "Unknown review ID";
      return;
    }
    this.fetchReview();
  },
  methods: {
    async fetchReview() {
      try {
        var resp = await this.$utils.callBackendPost(
          this,
          "/api/getReviewStatusAI",
          { reviewId: this.reviewId }
        );
        console.log("got review status: " + JSON.stringify(resp, null, 2));
        this.resumeUrl = resp.resumeUrl;
      } catch (error) {
        this.errorMsg = error;
      }
    },
  },
};
</script>
